import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import splashBackground from "../../assets/images/signIn-splash-screen.svg";
import {
  colors,
  fontFamily,
  hvCenter,
  pxtorem,
} from "../../assets/styles/theme";
import { Box, Button, Link, Typography } from "@mui/material";

import logoBlue from "../../assets/images/2060Digital-logo-blue.svg";
import Alert from "@mui/material/Alert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WarningIcon from "@mui/icons-material/Warning";

const HomeSignInSplashScreen = styled.div`
  height: calc(100% + 60px);
  margin-top: -60px;
  ${hvCenter};
  flex-direction: column;
  background: radial-gradient(at center, #fff 46.38%, #cdcdcd 100%);

  .splashBg {
    margin-top: -60px;
    width: 100%;
    max-width: 740px;
    height: 100%;
    max-height: 580px;

    background-image: url(${splashBackground});
    background-size: contain;
    background-repeat: no-repeat;
    .link-splash {
      margin: 46.5% 0 0 46%;
    }
  }
  .txt-copyright {
    font-family: ${fontFamily.karla};
    font-size: ${pxtorem(10)};
    color: ${colors.primaryDark};
    line-height: 11.69px;
    position: absolute;
    bottom: 20px;
  }
`;

const NotFound = () => {
  const navigate = useNavigate();

  const redirectToHome = () => {
    console.log("redirectToHome");
    navigate("/")
  }

  return (
    <>
      <HomeSignInSplashScreen>
        <Box  className="d-flex align-items-center justify-content-center flex-direction-column">
          <img
            src={logoBlue}
            alt="2060 Digital Logo"
            style={{ height: "65px", marginBottom: "10px" }}
          />
          <WarningIcon color="error" fontSize="large" sx={{ mb: 1, mt: 4 }} />
          <Typography
            variant="h1"
            component="h1"
            className=""
            color="error"
            sx={{ mb: 3 }}
          >
            404 Page not found!

          </Typography>
         
          <Button variant="contained" startIcon={<ArrowBackIcon />} className="btn-clearfilter" onClick={() => redirectToHome()}>
            Back to Home
          </Button>
          
        </Box>
      </HomeSignInSplashScreen>
    </>
  );
};

export default NotFound;
